import fpApiUtil from "./fp-api-util";

const BASE = "factoryplan/master/resource/resources";

const getAll = (params) => fpApiUtil.postParams(BASE, params);
const upsert = (changes) => fpApiUtil.postChanges(`${BASE}/save`, changes);
const remove = (changes) => fpApiUtil.postChanges(`${BASE}/delete`, changes);

const fpResourceService = { getAll, upsert, remove };
export default fpResourceService;
